import { frontendURL } from 'dashboard/helper/URLHelper';

// custom (2026-08-09, Lote 3): FLUXOS DE TRABALHO — a aba da administradora.
//
// ⚠️ SUBSTITUI a aba "Qualificação" (`triagemRoutes`), que foi REMOVIDA no mesmo commit. A
// razão é do Gustavo, vendo a tela: "ela tá com o mesmo layout de uma conversa e a
// administradora não vai responder, então está esquisito". Aquela aba reusava o
// `ConversationView` do core para mostrar a fila da IA — o desenho prometia uma caixa de
// atendimento e entregava uma tela de supervisão.
//
// O que ela fazia continua existindo, em melhor lugar: a fila virou o FEED do fluxo (raias
// por desfecho, não bolhas de conversa), e a tela de Desempenho virou o botão "Métricas"
// aqui dentro — "as métricas têm que viver dentro do fluxo", palavras dele.
//
// `permissions: ['administrator']` é o portão da NAVEGAÇÃO; o de verdade é a CrmFlowPolicy,
// que responde 401 para operador mesmo com a URL digitada à mão.
export const fluxosRoutes = [
  {
    path: frontendURL('accounts/:accountId/fluxos'),
    name: 'crm_fluxos',
    component: () => import('./CrmFluxos.vue'),
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/fluxos/:slug'),
    name: 'crm_fluxo',
    component: () => import('./CrmFluxo.vue'),
    meta: {
      permissions: ['administrator'],
    },
  },
];
